import { lazyLoad } from 'utils/loadable';

export const PlacementDocViewerLoadableClassic = lazyLoad(
  () => import('./PlacementDocViewerClassic'),
  module => module.PlacementDocViewerClassic,
);
